(() => {
  const moneyFormat = null;
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const WRAP_SEL = '#CartDrawer-Recommendations';
  const LIST_SEL = '#CartDrawer-RecommendationsList';

  let lastPid = null;
  let loading = false;
  let debounceTimer = null;

  const debounce = (fn, wait = 80) => { clearTimeout(debounceTimer); debounceTimer = setTimeout(fn, wait); };

  const formatMoney = (cents) => {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, moneyFormat);
      }
    } catch(e) {}
    return (cents / 100).toFixed(2);
  };

  const skeleton = (list, count = 6) => {
    list.innerHTML = '';
    for (let i = 0; i < count; i++) {
      const sk = document.createElement('div');
      sk.className = 'mini-cart-recs-skeleton';
      list.appendChild(sk);
    }
  };

  const availableVariant = (p) => (p.variants || []).find(v => v.available) || (p.variants ? p.variants[0] : null);
  const imgSrc = (p) => (p.images && p.images[0]) ? p.images[0] : null;

  const renderCard = (p) => {
    const v = availableVariant(p);
    const im = imgSrc(p);
    return `
      <div class="mini-cart-recs-card" data-product-id="${p.id}">
        <a href="${p.url}">
          ${im ? `<img loading="lazy" src="${im}" alt="${p.title.replace(/"/g,'&quot;')}" width="320" height="320">` : ''}
          <div class="mini-cart-recs-title">${p.title}</div>
        </a>
        <div class="mini-cart-recs-price">${formatMoney(p.price)}</div>
        ${v ? `
          <form class="mini-cart-recs-form" method="post" action="/cart/add">
            <input type="hidden" name="id" value="${v.id}">
            <button class="mini-cart-recs-btn" type="submit">${p.requires_selling_plan ? 'Ver opções' : 'Adicionar'}</button>
          </form>` :
          `<button class="mini-cart-recs-btn" disabled>Sem estoque</button>`
        }
      </div>
    `;
  };

  const refreshCartDrawer = async () => {
    try {
      const res = await fetch(`/?sections=cart-drawer&_=${Date.now()}`, { headers: { 'Accept': 'application/json' } });
      if (!res.ok) return;
      const data = await res.json();
      const html = data['cart-drawer'];
      if (!html) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.getElementById('CartDrawer');
      const currentDrawer = document.getElementById('CartDrawer');
      if (newDrawer && currentDrawer) {
        currentDrawer.innerHTML = newDrawer.innerHTML;
      }

      attachAddHandlers();

      const drawerEl = qs('cart-drawer');
      if (drawerEl) {
        if (typeof drawerEl.open === 'function') drawerEl.open();
        else drawerEl.setAttribute('open', '');
      }

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (err) {
      console.error('Erro ao atualizar cart drawer:', err);
    }
  };

  const attachAddHandlers = () => {
    qsa('.mini-cart-recs-form').forEach(form => {
      if (form.__bound) return;
      form.__bound = true;
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('button');
        btn.disabled = true;

        const data = new FormData(form);
        try {
          const addRes = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
          if (!addRes.ok) {
            const go = form.closest('.mini-cart-recs-card')?.querySelector('a')?.href;
            if (go) { window.location.href = go; return; }
          }

          await refreshCartDrawer();
        } catch (err) {
          console.error(err);
        } finally {
          btn.disabled = false;
        }
      });
    });
  };

  const refreshFromCart = async () => {
    if (loading) return;
    loading = true;

    const wrap = qs(WRAP_SEL);
    const list = qs(LIST_SEL);
    if (!wrap || !list) { loading = false; return; }

    try {
      const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await cartRes.json();

      if (!cart.items || !cart.items.length) {
        wrap.hidden = true;
        lastPid = null;
        loading = false;
        return;
      }

      const pid = cart.items[0].product_id;
      if (pid === lastPid && !wrap.hidden && list.children.length) {
        loading = false;
        return;
      }

      wrap.hidden = false;
      skeleton(list);

      const recRes = await fetch(`/recommendations/products.json?product_id=${pid}&limit=12`, { headers: { 'Accept': 'application/json' } });
      if (!recRes.ok) throw new Error('Falha ao buscar recomendações');
      const recData = await recRes.json();

      const cartIds = new Set(cart.items.map(i => i.product_id));
      const filtered = (recData.products || []).filter(p => !cartIds.has(p.id)).slice(0, 6);

      if (!filtered.length) {
        wrap.hidden = true;
        lastPid = pid;
        loading = false;
        return;
      }

      list.innerHTML = filtered.map(renderCard).join('');
      attachAddHandlers();
      lastPid = pid;
    } catch (e) {
      console.error('Recs error', e);
    } finally {
      loading = false;
    }
  };

  const installObserver = () => {
    const target = document.getElementById('CartDrawer') || qs('cart-drawer');
    if (!target) return;
    if (installObserver._observer) installObserver._observer.disconnect();
    const observer = new MutationObserver(() => debounce(refreshFromCart, 60));
    observer.observe(target, { childList: true, subtree: true });
    installObserver._observer = observer;
  };

  document.addEventListener('DOMContentLoaded', () => {
    installObserver();
    debounce(refreshFromCart, 0);
  });

  ['cart:updated','cart:refresh','cart-drawer:open'].forEach(evt => {
    document.addEventListener(evt, () => debounce(refreshFromCart, 60));
  });
})();
